module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik0xNy43NSA3TDE0IDMuMjVsLTEwIDEwVjE3aDMuNzVsMTAtMTB6bTIuOTYtMi45NmMuMzktLjM5LjM5LTEuMDIgMC0xLjQxTDE4LjM3LjI5Yy0uMzktLjM5LTEuMDItLjM5LTEuNDEgMEwxNSAyLjI1IDE4Ljc1IDZsMS45Ni0xLjk2eiIvPgogICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPgogICAgPHBhdGggZmlsbC1vcGFjaXR5PSIuMzYiIGQ9Ik0wIDIwaDI0djRIMHoiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/firma_digital.svg
// module id = glua
// module chunks = 0